<template>
    <Layout>
        <h1 v-bind:class="$style.title">
            The page timed out while loading. Are you sure you're still connected to the Internet?
        </h1>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: 'Page timeout',
            meta: [
                {
                    name: 'description',
                    content: 'The page timed out while loading.',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },
    };
</script>

<style lang="scss" module>
    .title {
        @apply text-center;
    }
</style>
